import {Fragment} from 'react';
import {KeySolver} from "../../KeySolver";

const Counter: (props: any) => JSX.Element = (props: any) => {

    const {questions, active} = props;

    return (
        <Fragment>
            <div className="mb-10 lg:mb-0 lg:absolute lg:left-0 lg:top-0 lg:h-[100%] lg:ms-10">
                <div className="flex justify-center lg:items-center h-[100%]">
                    <div className="flex flex:row lg:flex-col">
                        {questions && questions.map((item: any, i: number) =>
                            <Fragment key={KeySolver()} >
                                <div className={`flex w-[3px] h-[3px] lg:w-[8px] lg:h-[8px] transition-all ${active >= i ? 'checkbox-checked' : 'bg-gray-200'}`} ></div>
                                {/*<button className={`flex w-[10px] h-[10px] transition-all ${active >= i ? 'checkbox-checked' : 'bg-gray-200'}`} onClick={() => setActive(i)} />*/}
                            </Fragment>
                        )}
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default Counter;
